import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import {AuthService} from './auth.service';
import {ConfigService} from './config.service';
import {LogService} from './log.service';


@Injectable()
export class FestivalService {
	constructor(
		private http: Http,
		private authService: AuthService,
		private config: ConfigService,
		private log: LogService
	) {}


	indexDay = 0;

	timeSlots = [
		9,
		12,
		15,
		18,
		21
	];

	festival = null;

	timeSlotShowingsWrapper = {
		timeSlotShowings: []
	};


	getFestival() {
		console.log('<------ getFestival -------->');
		this.makeIndexDay();

		return new Promise( (resolve, reject) => {

			// if just opened app, get copy from local storage if it exists and is for this user
			if (!this.festival && localStorage) {
				console.log('got here #f1');
				let festivalString = localStorage.getItem('festival');
				if (festivalString) {
					console.log('got here #f2');
					let storedFestival = null;
					try {
						storedFestival = JSON.parse(festivalString);
					} catch (err) {
						this.log.error('Could not parse festivalString.');
						console.log('Could not parse festivalString.');
						this.log.error(err);

						storedFestival = null;
					}

					console.log('got here #f3');
					this.festival = storedFestival;
				}
			}

			// make async calls here
			if (this.festival) {
				console.log('got here #f6');

				this.http.get(this.config.basePath + '/v0/festival/timestamp')
					.toPromise()
					.then((res) => {
						let result = res.json();

						let newTimestamp = result.timestamp;
						console.log('newTimestamp');
						console.log(newTimestamp);

						console.log('-----checking time-----');
						console.log('newTimestamp            = ' + newTimestamp);
						console.log('this.festival.timestamp = ' + this.festival.timestamp);
						if (!newTimestamp || !this.festival.timestamp || (newTimestamp > this.festival.timestamp)) {
							console.log('got here #f10');

							this.http.get(this.config.basePath + '/v0/festival')
								.toPromise()
								.then((res2) => {
									let result2 = res2.json();
									this.festival = result2.festival;
									console.log('getFestival, festival');
									console.log(this.festival);

									try {
										localStorage.setItem('festival', JSON.stringify(this.festival));
										resolve(this.festival);
									} catch (err) {
										this.log.error(err);
										console.log(err);
										reject(err);
									}
								})
								.catch((err) => {			// this is a Response object, with res.status === 401, for example
									this.log.error(err);
									console.log(err);
									reject(err);
								});
						} else {
							console.log('got here #f13');
							resolve(this.festival);
						}
					})
					.catch((err) => {			// this is a Response object, with res.status === 401, for example
						this.log.error(err);
						console.log(err);
						reject(err);
					});
			} else {
				console.log('got here #f5');
				// no local storage version, so just grab the data and be done
				this.http.get(this.config.basePath + '/v0/festival')
					.toPromise()
					.then((res3) => {
						let result3 = res3.json();
						this.festival = result3.festival;
						console.log('getFestival, festival');
						console.log(this.festival);

						try {
							if (localStorage) {
								localStorage.setItem('festival', JSON.stringify(this.festival));
							}
						} catch (err) {
							// this.log.error(err);
							console.log(err);
							// reject(err);
						}
						resolve(this.festival);
					})
					.catch((err) => {			// this is a Response object, with res.status === 401, for example
						this.log.error(err);
						console.log(err);
						reject(err);
					});
			}
		});
	}


	getTimeSlotShowings() {
		console.log('<------ getTimeSlotShowings -------->');
		this.makeIndexDay();

		let now = new Date();
		let hour = now.getHours();
		// hour = fakeHour;

		let weekdayName = '';
		switch (this.indexDay) {
			case 0:
			weekdayName = 'friday';
			break;
			case 1:
			weekdayName = 'saturday';
			break;
			case 2:
			weekdayName = 'sunday';
			break;
		}

		let timeSlot = weekdayName + '+' + this.getCurrentTimeSlot(hour);
		console.log('timeSlot');
		console.log(timeSlot);


		return new Promise( (resolve, reject) => {

			// let accessToken = localStorage.getItem('auth-jwt');
			// let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			// let options = new RequestOptions({ headers: headers });

			// this.http.get(this.config.basePath + '/v0/festival/timestamp', options)
			this.http.get(this.config.basePath + '/v0/showings/' + timeSlot)
				.toPromise()
				.then((res) => {
					let result = res.json();
					this.timeSlotShowingsWrapper = result;

					console.log('this.timeSlotShowingsWrapper');
					console.log(this.timeSlotShowingsWrapper);


					resolve(result.timeSlotShowings);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					console.log(err);
					reject(err);
				});
		});
	}


	getCurrentShowings() {
		console.log('getCurrentShowings');
		this.makeIndexDay();

		let now = new Date();
		let hour = now.getHours();
		// hour = fakeHour;

		let returnShowings = [];
		let timeSlotName = 'No More Films Today';

		let timeSlotHour = this.getCurrentTimeSlot(hour);
		if (timeSlotHour) {
			returnShowings = this.getCurrentShowingz(timeSlotHour);
			timeSlotName = this.formatTimeSlot(timeSlotHour);
		}

		let allTicketsz = {
			modified: null,
			userId: '',
			timeSlotName: timeSlotName,
			// showingsTime: '3pm Time Slot',
			// showingsTime: '3pm Presentations',
			theatres: returnShowings
		};
		console.log('when the current hour is');
		console.log(hour);
		console.log('allTicketsz');
		console.log(allTicketsz);

		return allTicketsz;
	}





	private makeIndexDay() {
		let now = new Date();
		let dayOfWeek = now.getDay();
		// console.log('now');
		// console.log(now);
		// console.log('dayOfWeek');
		// console.log(dayOfWeek);

		this.indexDay = (dayOfWeek + 7 - 5) % 7;
		if (this.indexDay > 2) {
			this.indexDay = 0;
		}
		// console.log('this.indexDay');
		// console.log(this.indexDay);
	}


	private getCurrentShowingz(timeSlotHour) {
		console.log('<------ getCurrentShowingz -------->');
		this.makeIndexDay();

		let now = new Date();
		let hour = now.getHours();
		// hour = fakeHour;

		console.log('getCurrentShowingz, this.festival');
		console.log(this.festival);

		console.log('this.indexDay');
		console.log(this.indexDay);

		console.log('this.festival.festivalDays');
		console.log(this.festival.festivalDays);


		let returnShowings = [];

		let festivalDay = this.festival.festivalDays[this.indexDay];
		let showings = (festivalDay) ? festivalDay.showings : [];

		for (let i = 0; i < showings.length; i++) {
			let showing = showings[i];

			let parts = showing.showTime.split(':');
			let showingHour = parseInt(parts[0], 10);
			if (showingHour === timeSlotHour) {

				let film = this.festival.films[showing.filmId];
				let theatre = this.festival.theatres[showing.theatreId];

				let timeSlot = festivalDay.dayOfWeek.toLowerCase() + '+' + this.getCurrentTimeSlot(hour);
				let timeSlotShowing = {
					currentTicket: 1,
					lastTicket: theatre.totalSeats,
					soldOut: false,
					updated: '',
					modified: 0		// <--- TODO!!! double check
				};

				if (this.timeSlotShowingsWrapper.timeSlotShowings) {
					for (let j = 0; j < this.timeSlotShowingsWrapper.timeSlotShowings.length; j++) {
						let tempTimeSlotShowing = this.timeSlotShowingsWrapper.timeSlotShowings[j];
						let partz = tempTimeSlotShowing.showingKey.split('+');

						if ( (partz) &&  (partz.length > 0) && (tempTimeSlotShowing.timeSlot === timeSlot) && (partz[1] === showing.theatreId) ) {
							timeSlotShowing = tempTimeSlotShowing;
							timeSlotShowing.updated = this.convertToUpdatedTime(timeSlotShowing.modified);
							break;
						}
					}
				}

				let returnShowing = {
					theatre: theatre.name,
					name: theatre.name,
					film: film.title,
					showTime: this.convertTo12Hour(showing.showTime),
					// showTime: convertTo12Hour('12:00'),
					totalSeats: theatre.totalSeats,
					currentTicket: timeSlotShowing.currentTicket,
					lastTicket: timeSlotShowing.lastTicket,
					soldOut: timeSlotShowing.soldOut,
					// updated: '2:18pm',
					updated: timeSlotShowing.updated,
					noMoreFilmsToday: false,
					timeSlot: festivalDay.dayOfWeek.toLowerCase() + '+' + this.getCurrentTimeSlot(hour)
				};
// 					returnShowing.soldOut = true;

// //					if (showing.theatreId === 'rose-theatre') {
// 						returnShowing.currentTicket = 40;
// 						returnShowing.updated = '5:57pm'
// //					}

// 					if (showing.theatreId === 'northwest-maritime-center') {
// 						returnShowing.soldOut = false;
// 					}

				returnShowings.push(returnShowing);
			}
		}
		return returnShowings;
	}


	getCurrentShowingByTheatreId(theatreId) {
		console.log('----------- getCurrentShowingByTheatreId--------------------');
		this.makeIndexDay();
		console.log(theatreId);

		let now = new Date();
		let hour = now.getHours();
		// hour = fakeHour;


		let theatre = this.festival.theatres[theatreId];
		// console.log('theatre');
		// console.log(theatre);
		let festivalDay = this.festival.festivalDays[this.indexDay];

		let showings = festivalDay.showings;
		let currentShowing = null;
		for (let i = 0; i < showings.length; i++) {
			let showing = showings[i];
			if (showing.theatreId === theatreId) {
				console.log(showing);
				let parts = showing.showTime.split(':');
				let showingHour = parseInt(parts[0], 10);

				if (showingHour + 1 > hour) {
					currentShowing = showing;
					break;
				}

				// var showTime = new Date(2015, 8, 25+indexDay, parseInt(parts[0]), parseInt(parts[1]), 0);
				// console.log(showTime);
				// var showRolloverTime = new Date(2015, 8, 25+indexDay, parseInt(parts[0])+1, parseInt(parts[1]), 0);;
				// console.log(showRolloverTime);
			}
		}
		// console.log('when the current hour is');
		// console.log(hour);
		// console.log('currentShowing');
		// console.log(currentShowing);
		let timeSlot = festivalDay.dayOfWeek.toLowerCase() + '+' + this.getCurrentTimeSlot(hour);

		// console.log('timeSlotzzzzz');
		// console.log(timeSlot);

		// console.log('this.timeSlotShowings');
		// console.log(this.timeSlotShowings);

		// console.log('this.timeSlotShowings.length');
		// console.log(this.timeSlotShowings.length);

		let timeSlotShowing = {
			currentTicket: 1,
			lastTicket: theatre.totalSeats,
			soldOut: false,
			updated: '',
			modified: 0
			// updated: convertToUpdatedTime(now.valueOf()),
		};
		if (this.timeSlotShowingsWrapper.timeSlotShowings) {
			for (let j = 0; j < this.timeSlotShowingsWrapper.timeSlotShowings.length; j++) {
				let tempTimeSlotShowing = this.timeSlotShowingsWrapper.timeSlotShowings[j];
				// if (tempTimeSlotShowing.timeSlot === timeSlot) {
				// 	timeSlotShowing = tempTimeSlotShowing;
				// 	break;
				// }


				let partz = tempTimeSlotShowing.showingKey.split('+');

				if ( (partz) &&  (partz.length > 0) && (tempTimeSlotShowing.timeSlot === timeSlot) && (partz[1] === theatreId) ) {
					timeSlotShowing = tempTimeSlotShowing;
					timeSlotShowing.updated = this.convertToUpdatedTime(timeSlotShowing.modified);
					break;
				}

			}
		}
		console.log('timeSlotShowing');
		console.log(timeSlotShowing);

		let returnShowing = {};
		if (currentShowing) {
			let film = this.festival.films[currentShowing.filmId];
			returnShowing = {
				dayOfWeek: festivalDay.dayOfWeek.toLowerCase(),
				showTime: currentShowing.showTime,
				theatre: theatre.name,
				theatreKey: theatreId,
				film: film.title,
				filmKey: currentShowing.filmId,
				showTime12Hour: this.convertTo12Hour(currentShowing.showTime),
				totalSeats: theatre.totalSeats,
				currentTicket: timeSlotShowing.currentTicket,
				lastTicket: timeSlotShowing.lastTicket,
				soldOut: timeSlotShowing.soldOut,
				updated: this.convertToUpdatedTime(timeSlotShowing.modified),
				noMoreFilmsToday: false,
				timeSlot: festivalDay.dayOfWeek.toLowerCase() + '+' + this.getCurrentTimeSlot(hour)
			};
		} else {
			returnShowing = {
				theatre: '',
				theatreKey: '',
				film: 'No more films today.',
				filmKey: '',
				showTime: '',
				totalSeats: 0,
				currentTicket: 0,
				lastTicket: 0,
				soldOut: false,
				updated: '',
				noMoreFilmsToday: true,
				timeSlot: ''
			};
		}
		console.log('returnShowing');
		console.log(returnShowing);

		return returnShowing;
	}


	createTicketCount(payload) {
		console.log('<------ createTicketCount -------->');
		console.log('payload');
		console.log(payload);

		return new Promise((resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let userId = this.authService.userId;
			// let payload = {
			// 	feedbackId: uuid.v4().replace(/-/g, ''),
			// 	feedbackUserId: userId,
			// 	feedback: feedback
			// };
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/ticketcounts', body, options)
				.toPromise()
				.then((res) => {
					let result = res.json();
					console.log(result);
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					console.log(err);
					reject(err);
				});
		});
	}


	getShowingsInfo() {
		console.log('getShowingsInfo');

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/showings', options)
				.toPromise()
				.then((res) => {
					let result = res.json();

					console.log('result');
					console.log(result);

					resolve(result.showings);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					console.log(err);
					reject(err);
				});
		});
	}


	private getCurrentTimeSlot(hour) {
		for (let i = 0; i < this.timeSlots.length; i++) {
			let timeSlot = this.timeSlots[i];
			if (timeSlot + 1 > hour) {
				return timeSlot;
			}
		}
		return null;
	}


	private formatTimeSlot(timeSlotHour) {
		let suffix = 'am';
		if ( timeSlotHour === 12 ) {
			suffix = 'noon';
		} else if (timeSlotHour >= 12) {
			suffix = 'pm';
		}
		// console.log('suffix');
		// console.log(suffix);

		if (timeSlotHour > 12) {
			timeSlotHour -= 12;
			return timeSlotHour + suffix + ' Films';
		} else {
			return timeSlotHour + suffix + ' Films';
		}
	}


	private convertTo12Hour(time) {
		let parts = time.split(':');
		let hour = parseInt(parts[0], 10);
		let minute = parseInt(parts[1], 10);
		// console.log('hour');
		// console.log(hour);
		// console.log('minute');
		// console.log(minute);

		let suffix = 'am';
		if ((hour === 12) && (minute === 0)) {
			suffix = 'noon';
		} else if (hour >= 12) {
			suffix = 'pm';
		}
		// console.log('suffix');
		// console.log(suffix);

		if (hour > 12) {
			hour -= 12;
			return hour + ':' + parts[1] + suffix;
		} else {
			return time + suffix;
		}
	}


	private convertToUpdatedTime(timeUtc) {
		if (!timeUtc) {
			timeUtc = Date.now();
		}

		let date = new Date(timeUtc);
		let hour = date.getHours();
		let minute = date.getMinutes();
		// console.log('hour');
		// console.log(hour);
		// console.log('minute');
		// console.log(minute);

		let suffix = 'am';
		if ((hour === 12) && (minute === 0)) {
			suffix = 'noon';
		} else if (hour >= 12) {
			suffix = 'pm';
		}
		// console.log('suffix');
		// console.log(suffix);

		let minuteText = '' + minute;
		if (minute < 10) {
			minuteText = '0' + minute;
		}
		if (hour > 12) {
			hour -= 12;
		}
		let updatedTime = hour + ':' + minuteText + suffix;
		// console.log('updatedTime');
		// console.log(updatedTime);

		return updatedTime;
	}
















/*
	getEvents() {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/events', options)
				.toPromise()
				.then( (res) => {
					resolve(res.json());
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});
	}



	// might not be useful, can not edit an event if you are on a different organization
	getEventsAllOrganizations() {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/eventsallorganizations', options)
				.toPromise()
				.then( (res) => {
					resolve(res.json());
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});
	}



	updateEvent(eventId: any, payload: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/events/' + eventId, body, options)
				.toPromise()
				.then((res) => {
// console.log('res');
// console.log(res);
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});
	}


	createEvent(payload: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/events', body, options)
				.toPromise()
				.then((res) => {
// console.log('res');
// console.log(res);
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});

	}
*/














/*




'use strict';


angular.module('app').factory('ApiTicketService', ['$http', '$q', 'Log', 'ConfigService', 'AuthService', 'ApiQueueService',
	function($http, $q, Log, ConfigService, AuthService, ApiQueueService) {

		var apiHost = ConfigService.getApiHost();

//		console.log('------ ApiTicketService --------');


//TODO!!! - remove all these
//		var fakeHour = 17;


		var now = new Date();
		var dayOfWeek = now.getDay();
//		console.log(now);
//		console.log(dayOfWeek);
		var indexDay = (dayOfWeek + 7 - 5) % 7;
//		console.log(indexDay);
		if (indexDay > 2) {
			indexDay = 0;
		}

//		console.log(indexDay);


		var allTickets = {
			modified: null,
			userId: '',
			timeSlotName: '3pm Films',
//			showingsTime: '3pm Time Slot',
//			showingsTime: '3pm Presentations',
			theatres: [{
				name: 'The Starlight Room',
				film: 'WA 2 WA Shorts Program',
				showTime: '3:00pm',
				totalSeats: 45,
				currentTicket: 1,
				lastTicket: 45,
				soldOut: false,
				updated: '2:18pm'
			}, {
				name: 'Key City Public Theatre',
				film: 'The Little Death',
				showTime: '3:00pm',
				totalSeats: 66,
				currentTicket: 1,
				lastTicket: 66,
				soldOut: false,
				updated: '2:18pm'
			}, {
				name: 'Peter Simpson Free Cinema',
				film: 'Austin to Boston',
				showTime: '3:00pm',
				totalSeats: 100,
				currentTicket: 1,
				lastTicket: 100,
				soldOut: true,
				updated: '2:18pm'
			}, {
				name: 'Rose Theatre',
				film: 'Sweet Land',
				showTime: '3:15pm',
				totalSeats: 158,
				currentTicket: 1,
				lastTicket: 158,
				soldOut: false,
				updated: '2:18pm'
			}, {
				name: 'Northwest Maritime Center',
				film: 'Austin to Boston',
				showTime: '3:15pm',
				totalSeats: 200,
				currentTicket: 1,
				lastTicket: 200,
				soldOut: false,
				updated: '2:18pm'
			}, {
				name: 'Rosebud Cinema',
				film: 'The Breach',
				showTime: '3:30pm',
				totalSeats: 79,
				currentTicket: 1,
				lastTicket: 79,
				soldOut: false,
				updated: '2:18pm'
			}, {
				name: 'American Legion Theatre',
				film: 'Frame By Frame',
				showTime: '3:30pm',
				totalSeats: 250,
				currentTicket: 1,
				lastTicket: 250,
				soldOut: false,
				updated: '2:18pm'
			}]
		};


		// reset
		// allTickets.theatres[0].currentTicket = 1;
		// allTickets.theatres[0].lastTicket = 45;
		// allTickets.theatres[0].soldOut = false;
		// allTickets.theatres[0].updated = '';

		// allTickets.theatres[1].currentTicket = 1;
		// allTickets.theatres[1].lastTicket = 66;
		// allTickets.theatres[1].soldOut = false;
		// allTickets.theatres[1].updated = '';

		// allTickets.theatres[2].currentTicket = 1;
		// allTickets.theatres[2].lastTicket = 100;
		// allTickets.theatres[2].soldOut = false;
		// allTickets.theatres[2].updated = '';

		// allTickets.theatres[3].currentTicket = 1;
		// allTickets.theatres[3].lastTicket = 158;
		// allTickets.theatres[3].soldOut = false;
		// allTickets.theatres[3].updated = '';

		// allTickets.theatres[4].currentTicket = 1;
		// allTickets.theatres[4].lastTicket = 200;
		// allTickets.theatres[4].soldOut = false;
		// allTickets.theatres[4].updated = '';

		// allTickets.theatres[5].currentTicket = 1;
		// allTickets.theatres[5].lastTicket = 79;
		// allTickets.theatres[5].soldOut = false;
		// allTickets.theatres[5].updated = '';

		// allTickets.theatres[6].currentTicket = 1;
		// allTickets.theatres[6].lastTicket = 250;
		// allTickets.theatres[6].soldOut = false;
		// allTickets.theatres[6].updated = '';


		// // example
		allTickets.theatres[0].currentTicket = 40;
		allTickets.theatres[0].lastTicket = 45;
		allTickets.theatres[0].soldOut = false;
		allTickets.theatres[0].updated = '2:18pm';

		allTickets.theatres[1].currentTicket = 46;
		allTickets.theatres[1].lastTicket = 66;
		allTickets.theatres[1].soldOut = false;
		allTickets.theatres[1].updated = '2:19pm';

		allTickets.theatres[2].currentTicket = 67;
		allTickets.theatres[2].lastTicket = 100;
		allTickets.theatres[2].soldOut = false;
		allTickets.theatres[2].updated = '2:05pm';

		allTickets.theatres[3].currentTicket = 26;
		allTickets.theatres[3].lastTicket = 158;
		allTickets.theatres[3].soldOut = false;
		allTickets.theatres[3].updated = '2:10pm';

		allTickets.theatres[4].currentTicket = 76;
		allTickets.theatres[4].lastTicket = 200;
		allTickets.theatres[4].soldOut = false;
		allTickets.theatres[4].updated = '2:15pm';

		allTickets.theatres[5].currentTicket = 4;
		allTickets.theatres[5].lastTicket = 79;
		allTickets.theatres[5].soldOut = false;
//		allTickets.theatres[5].updated = '1:58pm';
		allTickets.theatres[5].updated = '';

		allTickets.theatres[6].currentTicket = 18;
		allTickets.theatres[6].lastTicket = 250;
		allTickets.theatres[6].soldOut = false;
		allTickets.theatres[6].updated = '2:17pm';


// console.log(allTickets);
// console.log(allTickets.theatres);
// console.log(allTickets.theatres[0]);

		var tempFestival = null;

		var festival = {
			timestamp: null,
//			userId: '',
			films: [],
			theatres: [],
			festivalDays: []
			// filmsById: {},
			// filmsBySubmissionId: {}
		};

		var timeSlotShowingsWrapper = {
			timeSlotShowings: []
		};

		// {
		// 	showingKey: {
		// 		type: String,
		// 		default: '',
		// 		trim: true,
		// 		required: 'showingKey cannot be blank'
		// 	},
		// 	filmKey: {
		// 		type: String,
		// 		default: '',
		// 		trim: true,
		// 		required: 'filmKey cannot be blank'
		// 	},
		// 	currentTicket: {
		// 		type: Number,
		// 		default: '',
		// 		required: 'currentTicket cannot be blank'
		// 	},
		// 	lastTicket: {
		// 		type: Number,
		// 		default: '',
		// 		required: 'lastTicket cannot be blank'
		// 	},
		// 	soldOut: {
		// 		type: Boolean,
		// 		default: false,
		// 		required: 'soldOut cannot be blank'
		// 	},
		// 	timeSlot: {
		// 		type: String,
		// 		default: '',
		// 		trim: true,
		// 		required: 'timeSlot cannot be blank'
		// 	},


		// }






		// var tempAvailableFilmIds = null;

		// var availableFilmIds = {
		// 	modified: null,
		// 	userId: '',
		// 	filmIds: []
		// };



		// function convertHourStringTo12HourFormat(hour) {
		// 	var parts = time.split(':');
		// 	var showingHour = parseInt(parts[0]);

		// 	if (showingHour+1 > hour) {
		// 		currentShowing = showing;
		// 		break;
		// 	}

		// }




		return {
			festival: festival,
//			timeSlotShowings: timeSlotShowingsWrapper.timeSlotShowings,
			timeSlotShowingsWrapper: timeSlotShowingsWrapper,

			allTickets: allTickets,

			getAllTickets: function() {
				return allTickets;
			},



			privateUpdateProperties: function() {
				var that = this;
				if (tempFestival) {
					angular.forEach(tempFestival, function(value, key) {
						that.festival[key] = tempFestival[key];
					});
				}

				// var jsonFilmsById = {};
				// var jsonFilmsBySubmissionId = {};
				// that.allFilms.films.forEach(function(film) {
				// 	jsonFilmsById[film.filmId] = film;
				// 	jsonFilmsBySubmissionId[film.submissionId] = film;
				// });
				// that.allFilms.filmsById = jsonFilmsById;
				// that.allFilms.filmsBySubmissionId = jsonFilmsBySubmissionId;



			},







			// theatres: [{
			// 	name: 'The Starlight Room',
			// 	film: 'WA 2 WA Shorts Program',
			// 	showTime: '3:00pm',
			// 	totalSeats: 45,
			// 	currentTicket: 1,
			// 	lastTicket: 45,
			// 	soldOut: false,
			// 	updated: '2:18pm'
			// }, {



			// showingsTime: '3pm Films',
			// theatres: [{
			// 	name: 'The Starlight Room',
			// 	film: 'WA 2 WA Shorts Program',
			// 	showTime: '3:00pm',
			// 	totalSeats: 45,
			// 	currentTicket: 1,
			// 	lastTicket: 45,
			// 	soldOut: false,
			// 	updated: '2:18pm'
			// }, {

















// 			updateFilm: function(payload) {
// //				console.log('<------ updateFilm -------->');
// 				// console.log('payload.filmId');
// 				// console.log(payload.filmId);
// 				// console.log('payload');
// 				// console.log(payload);

// 				var fullUrl = apiHost + '/v0/films/' + payload.filmId;
// 				ApiQueueService.addQueue('put', fullUrl, payload);
// 				ApiQueueService.flushQueue();

// 			},



// 			createFilm: function(payload) {
// //				console.log('<------ createFilm -------->');
// 				// console.log('payload');
// 				// console.log(payload);

// 				var fullUrl = apiHost + '/v0/films';
// 				ApiQueueService.addQueue('post', fullUrl, payload);
// 				ApiQueueService.flushQueue();
// 			},













// 			availableFilmIds: availableFilmIds,



// 			privateUpdateAvailableFilmIdProperties: function() {
// 				var that = this;
// 				if (tempAvailableFilmIds) {
// 					angular.forEach(tempAvailableFilmIds, function(value, key) {
// 						that.availableFilmIds[key] = tempAvailableFilmIds[key];
// 					});
// 				}
// 			},



// 			getAvailableFilmIds: function() {
// //				console.log('<------ getAvailableFilmIds -------->');
// 				var that = this;
// 				return $q(function(resolve, reject) {

// 					// get userId from auth service
// 					var auth = AuthService.getAuth();
// 					if (!auth) {
// 						return resolve(null);
// 					}
// 					if (!auth.userId) {
// 						return resolve(null);
// 					}
// 					var userId = auth.userId;


// 					// if just opened app, get copy from local storage if it exists and is for this user
// 					if (!tempAvailableFilmIds) {
// //						console.log('got here #a1');
// 						var availableFilmIdsString = localStorage.getItem('user-films');
// 						if (availableFilmIdsString) {
// //							console.log('got here #a2');
// 							var storedAvailableFilmIds = null;
// 							try {
// 								storedAvailableFilmIds = JSON.parse(availableFilmIdsString);
// 							} catch (ex) {
// 								Log.error('Could not parse availableFilmIdsString.');
// 								Log.error(ex);
// 								storedAvailableFilmIds = null;
// 							}

// 							// check to make sure correct userId
// 							if (storedAvailableFilmIds && (storedAvailableFilmIds.userId === userId) ) {
// //								console.log('got here #a3');
// 								tempAvailableFilmIds = storedAvailableFilmIds;
// 								that.privateUpdateAvailableFilmIdProperties();
// 							} else {
// //								console.log('got here #a4');
// 								// remove the local storage as it was for another user
// 								localStorage.removeItem('user-films');
// 							}
// 						}
// 					}

// 					// make async calls here
// 					if (tempAvailableFilmIds) {
// //						console.log('got here #a6');

// 						$http.get(apiHost + '/v0/films/users/' + userId + '/date')
// 						.success(function(data, status, headers, config) {
// //							console.log('got here #a11');

// 							var availableFilmIdsDate = data.modified;
// 							// console.log('-----checking time-----');
// 							// console.log('availableFilmIdsDate          = ' + availableFilmIdsDate);
// 							// console.log('tempAvailableFilmIds.modified = ' + tempAvailableFilmIds.modified);
// 							if ( (!availableFilmIdsDate) || (availableFilmIdsDate > tempAvailableFilmIds.modified) || (tempAvailableFilmIds.userId !== userId)  ) {
// //								console.log('got here #a10');

// 								$http.get(apiHost + '/v0/films/users/' + userId)
// 								.success(function(data, status, headers, config) {
// //									console.log('got here #a28');

// 									tempAvailableFilmIds = data.availableFilmIds;
// 									localStorage.setItem('user-films', JSON.stringify(tempAvailableFilmIds));

// 									that.privateUpdateAvailableFilmIdProperties();
// 									return resolve(that.availableFilmIds);
// 								})
// 								.error(function(data, status, headers, config) {
// //									console.log('got here #a29');

// 									Log.warn('Could not get available filmIds from api.');
// 									return resolve(null);
// 								});

// 							} else {
// 								// we have current data, so we're all done
// //								console.log('got here #a13');
// 								// console.log('we are all good!!');
// 								that.privateUpdateAvailableFilmIdProperties();
// 								return resolve(that.availableFilmIds);
// 							}

// 						})
// 						.error(function(data, status, headers, config) {
// //							console.log('got here #a12');

// 							Log.warn('Could not get available filmIds date from api.');
// 							return resolve(null);
// 						});

// 					} else {
// //						console.log('got here #a5');
// 						// no local storage version, so just grab the data and be done
// 						$http.get(apiHost + '/v0/films/users/' + userId)
// 						.success(function(data, status, headers, config) {
// //							console.log('got here #a8');

// 							tempAvailableFilmIds = data.availableFilmIds;
// 							localStorage.setItem('user-films', JSON.stringify(tempAvailableFilmIds));

// 							that.privateUpdateAvailableFilmIdProperties();
// 							return resolve(that.availableFilmIds);
// 						})
// 						.error(function(data, status, headers, config) {
// //							console.log('got here #a9');

// 							Log.warn('Could not get available filmIds from api.');
// 							return resolve(null);
// 						});
// 					}
// 				});
// 			},






// 			exportProgramFilms: function(filename, data, callback) {
// 				// console.log('<------ exportProgramFilms -------->');
// 				// console.log('filename');
// 				// console.log(filename);
// 				// console.log('data');
// 				// console.log(data);

// 				var fullUrl = apiHost + '/v0/films/program';

// 				var payload = {
// 					filename: filename,
// 					data: data
// 				};

// 				$http.post(fullUrl, payload)
// 				.success(function(data, status, headers, config) {
// //					console.log('got here #exportProgramFilms1');

// 					return callback(null, data);

// 				})
// 				.error(function(data, status, headers, config) {
// 					// console.log('got here #exportProgramFilms2');

// 					var message = 'exportProgramFilms could not post to api.';
// 					Log.warn(message);

// 					return callback(new Error(message));
// 				});
// 			},






		};
	}
]);





















*/






}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/festival.service.ts